import React from 'react';
import { LinkListCardProps } from 'types/link-list-card-props';

const LinkListCard: React.FC<LinkListCardProps> = ({ headline, links }) => (
        <div className="link-list-card">
            <h3 className="headline">{headline}</h3>
            <ul role="list">
                {links.map((link, index) => (
                    <li key={index}>
                        <a href={link.url}>
                            <link.icon />
                            <span>{link.text}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
);

export default LinkListCard;